// Shared formatting for the Transactions ledger (doc 05). Money is stored as
// integer cents + an ISO currency; format per the row's own currency so mixed-
// currency ledgers stay honest (doc 09 #5 — no FX).
export const formatMoney = (cents, currency) => {
  if (cents == null) return "—"
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: currency || "USD",
    }).format(cents / 100)
  } catch {
    return `${(cents / 100).toFixed(2)} ${currency || ""}`.trim()
  }
}

// Live discount snapshot (Partner API activeSubscription, unstable version) --
// percentage takes precedence when both are somehow present. Returns null
// when the subscription has no discount at all.
export const formatDiscount = (sub) => {
  if (sub.discount_percentage != null) return `${sub.discount_percentage}%`
  if (sub.discount_amount_cents != null) return formatMoney(sub.discount_amount_cents, sub.currency)
  return null
}

export const formatDateTime = (iso) => {
  if (!iso) return "—"
  const d = new Date(iso)
  return Number.isNaN(d.getTime()) ? "—" : d.toLocaleString()
}
